import { useListProjectPhasesForAccountQuery } from "@generated";
import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";
import { ProjectPhase } from "../../types";

const useListProjectPhases = (project_id) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  let customError: string | null = null; // Declare customError

  const { data, error, isLoading, refetch, isFetching } =
    useListProjectPhasesForAccountQuery({
      slug: accountSlug,
      filter: { active: true, project: project_id },
    });

  let phases: ProjectPhase[] = [];

  if (data?.data) {
    try {
      phases = data.data.map((phase) => {
        if (!phase.id) {
          throw new Error("Missing phase.id");
        }
        if (!phase.attributes?.name) {
          throw new Error("Missing phase.attributes.name");
        }

        return {
          id: String(phase.id),
          type: "project-phases",
          name: phase.attributes.name,
          position: phase.attributes?.position || -1,
        };
      });
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }
  return {
    fetchedPhases: phases,
    phasesLoading: isLoading,
    error: error ?? customError,
    refetchPhases: refetch,
    phasesFetching: isFetching,
  };
};
export default useListProjectPhases;
